import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Panel, PageHead } from "@/components/common";
import { useApi, errMsg } from "@/lib/api";

const FIELDS = [
  ["upi_id", "Your UPI ID (members pay here)", "text"],
  ["upi_name", "Payee name shown in UPI apps", "text"],
  ["package_price", "Joining package price (₹)", "number"],
  ["referral_bonus", "Direct referral bonus — level 1 (₹)", "number"],
  ["level2_bonus", "Level 2 bonus — sponsor's sponsor (₹)", "number"],
  ["level3_bonus", "Level 3 bonus (₹)", "number"],
  ["min_withdrawal", "Minimum withdrawal (₹)", "number"],
];

export default function Settings() {
  const api = useApi();
  const { me, refresh } = useOutletContext();
  const [form, setForm] = useState(me.settings);
  const [busy, setBusy] = useState(false);
  useEffect(() => setForm(me.settings), [me.settings]);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    const body = Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === "number" ? Number(form[k]) : form[k]]));
    try { await api("put", "/admin/settings", body); toast.success("Settings saved"); refresh(); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div data-testid="admin-settings-page">
      <PageHead label="Admin" title="Plan settings" />
      <Panel className="max-w-2xl">
        <form onSubmit={save} className="space-y-5">
          {FIELDS.map(([k, label, type]) => (
            <div key={k}>
              <label className="mb-1.5 block text-sm text-slate-400" htmlFor={k}>{label}</label>
              <Input id={k} data-testid={`settings-${k.replace(/_/g, "-")}-input`} type={type} value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className={type === "number" ? "font-mono" : ""} />
            </div>
          ))}
          <Button type="submit" disabled={busy} data-testid="settings-save-btn" className="rounded-full px-8 font-semibold">{busy ? "Saving…" : "Save settings"}</Button>
        </form>
      </Panel>
    </div>
  );
}
